import { Box } from '@everlywell/ui-kit';
import React from 'react';
import { sanitize } from 'utils/domHelpers';

type BulletListProps = {
  htmlData: string;
  color?: string;
  reduceMargin?: boolean;
};

const BulletList = ({ htmlData, color, reduceMargin }: BulletListProps) => (
  <Box
    color={color || 'white'}
    fontSize={['md', 'lg']}
    fontWeight="400"
    lineHeight="150%"
    dangerouslySetInnerHTML={{
      __html: sanitize(htmlData),
    }}
    sx={{
      li: {
        listStylePosition: 'outside',
        marginBottom: reduceMargin ? 2 : 3,
        marginLeft: [4],
        lineHeight: 1.43,
      },
    }}
  ></Box>
);

export default BulletList;
